module.exports = __webpack_public_path__ + "static/media/hack3.bcad32e6.jpg";